export const roleUrls = {
  list: "/admin/roles",
};
export const userUrls = {
  list: "/admin/users",
};
export const downloadableMaterial = {
  adminFreeFeQuiz: "/admin/free-fe-quiz",
  adminFreeModelTest: "/admin/free-fe-model-test",
  adminMechanicalFreeModelTest: "/admin/mechanical/free-fe-model-test",
  adminFreeMaterial: "/admin/free-fe-material",
  adminMechanicalFreeMaterial: "/admin/mechanical/free-fe-material",
  adminPaidModelTest: "/admin/paid-model-test",
  adminMechanicalPaidModelTest: "/admin/mechanical/paid-model-test",
  adminSubscriptionMaterials: "/admin/subscription-materials",
  adminMechanicalSubscriptionMaterials:
    "/admin/mechanical/subscription-materials",
};
export const testUrls = {
  list: "/admin/tests",
};
export const chapterUrls = {
  list: "/admin/chapters",
  pageCivil: "/admin/civil/quiz-bank",
  pageMechanical: "/admin/mechanical/quiz-bank",
};
export const simulatorUrls = {
  list: "/admin/model-test",
  freeModelTestTakers: "/admin/free-model-test",
  questions: "/admin/model-test/:id",
  pageCivil: "/admin/civil/simulator",
  pageMechanical: "/admin/mechanical/simulator",
};
export const subChapterUrls = {
  list: "/admin/chapters/subchapters/:id",
};
export const subChapterQuestionUrls = {
  list: "/admin/chapters/subchapters/questions/:id",
};
export const newsUrls = {
  list: "/admin/news",
};
export const materialUrls = {
  list: "/admin/materials",
};
export const staticPagesUrls = {
  home: "/admin/static/home",
  aboutUs: "/admin/static/about-us",
  singlePage: "/admin/static/single-page",
  contact: "/admin/static/contact",
  privacyPolicy: "/admin/static/privacy-policy",
  termsOfService: "/admin/static/terms-of-service",
  footer: "/admin/static/footer-pages",
};
export const blogUrls = {
  list: "/admin/blogs",
};
export const dashboardUrls = {
  admin: "/admin/dashboard",
  student: "/student/dashboard",
};
export const publicUrls = {
  Home: "/",
  About: "/about-us",
  NewsArchive: "/news-archive",
  Contact: "/contact-us",
  LiveOnlineClass: "/live-online-class",
  Tutorial: "/tutorial",
  SelfStudy: "/self-study",
  News: "/news/:slug",
  BlogsArchive: "/blogs",
  Blog: "/blog/:slug",
  CivilCourses: "/civil/courses",
  MechanicalCourses: "/mechanical/courses",
  LiveClassCivil: "/civil/live-class",
  LiveClassMechanical: "/mechanical/live-class",
  FreeFeTestCivil: "/civil/free-fe-model-test",
  FreeFeTestMechanical: "/mechanical/free-fe-model-test",
  FreeFeMaterialsCivil: "/civil/free-fe-materials",
  FreeFeMaterialsMechanical: "/mechanical/free-fe-materials",
  PaidModelTestCivil: "/civil/paid-model-test",
  PaidModelTestMechanical: "/mechanical/paid-model-test",
  tutoringCivil: "/civil/tutoring",
  tutoringMechanical: "/mechanical/tutoring",
  feSubscriptionCivil: "/civil/subscription-materials",
  feSubscriptionMechanical: "/mechanical/subscription-materials",
  practiceHubCivil: "/civil/practice-hub",
  practiceHubMechanical: "/mechanical/practice-hub",
  quizBankCivil: "/civil/quiz-bank",
  quizBankMechanical: "/mechanical/quiz-bank",
  simulatorCivil: "/civil/simulator",
  simulatorMechanical: "/mechanical/simulator",
  PrivacyPolicies: "/privacy-policies",
  TermsOfServices: "/terms-of-services",
  staticPage: "/:slug",
};
export const one2OneTutoring = {
  pageCivil: "/admin/civil/tutoring",
  pageMechanical: "/admin/mechanical/tutoring",
  packages: "/admin/tutoring-packages",
  purchase: "/admin/tutoring-purchase",
};
export const practiceHubUrls = {
  pageCivil: "/admin/civil/practice-hub",
  pageMechanical: "/admin/mechanical/practice-hub",
  adminTopic: "/admin/topic",
  adminSubTopicTopic: "/admin/sub-topic",
};

export const liveClassUrls = {
  pageCivil: "/admin/live-class",
  pageMechanical: "/admin/mechanical/live-class",
  liveClasses: "/admin/live-classes",
  liveClassItem: "/admin/live-classes/:id",
};

//student urls
export const studentUrls = {
  liveClass: "/student/live-class",
  liveClassMechanical: "/student/mechanical/live-class",
  studentSubscriptionMaterials: "/student/subscription-materials",
  studentSubscriptionMaterialsMechanical:
    "/student/mechanical/subscription-materials",
  studentPracticeHub: "/student/practice-hub",
  studentPracticeHubMechanical: "/student/mechanical/practice-hub",
  studentPaidModelTest: "/student/paid-model-test",
  studentPaidModelTestMechanical: "/student/mechanical/paid-model-test",
  studentTutoring: "/student/tutoring",
  studentTutoringMechanical: "/student/mechanical/tutoring",
  studentQuizBankCivil: "/student/civil/quiz-bank",
  studentQuizBankMechanical: "/student/mechanical/quiz-bank",
  studentSimulatorCivil: "/student/civil/simulator",
  studentSimulatorMechanical: "/student/mechanical/simulator",
};
export const profileUrl = "/profile";
